import { RSAA } from 'redux-api-middleware';
import getGenresUrl from 'url-constructors/getGenresURL';
import { Dispatch } from 'redux';
import { TGetRootState, TAsyncDispatchResult } from 'types/shared';
import { IGenreProps } from 'types/shared';

const REQUEST = 'opus/genres/REQUEST';
const SUCCESS = 'opus/genres/SUCCESS';
const FAILURE = 'opus/genres/FAILURE';

type GenresActionTypes = typeof REQUEST | typeof SUCCESS | typeof FAILURE;

interface IGenresState {
  pending: boolean;
  fulfilled: boolean;
  error: boolean;
  reason: any;
  data: IGenreProps[];
}

interface IGenresAction {
  type: GenresActionTypes;
  payload: IGenreProps[];
}

const initialState: IGenresState = {
  pending: false,
  fulfilled: false,
  error: false,
  reason: null,
  data: [],
};

function reducer(
  state: IGenresState = initialState,
  action: IGenresAction
): IGenresState {
  switch (action.type) {
    case REQUEST: {
      return {
        ...state,
        pending: true,
        fulfilled: false,
        error: false,
      };
    }
    case SUCCESS: {
      return {
        ...state,
        pending: false,
        fulfilled: true,
        error: false,
        data: action.payload,
      };
    }
    case FAILURE: {
      return {
        ...state,
        pending: false,
        fulfilled: false,
        error: true,
        reason: action.payload,
      };
    }
    default: {
      return state;
    }
  }
}

function loadGenres(): TAsyncDispatchResult {
  return async function (
    dispatch: Dispatch,
    getState: TGetRootState
  ): Promise<any> {
    const { genres } = getState();

    return await dispatch({
      [RSAA]: {
        bailout: genres.pending || genres.fulfilled,
        types: [
          REQUEST,
          {
            type: SUCCESS,
            payload: async function payload(
              action: IGenresAction,
              state: IGenresState,
              res: any
            ): Promise<IGenreProps[]> {
              const json = await res.json();
              return json;
            },
          },
          FAILURE,
        ],
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        method: 'GET',
        endpoint: getGenresUrl(),
      },
    });
  };
}

export { loadGenres };
export default reducer;
